// service/apiHelpers.js
import { fetchWrapper } from "utils/apiFetch";

/**
 * Builds a URLSearchParams body matching the curl `--data-urlencode` format
 * used by the backend (application/x-www-form-urlencoded).
 *
 * @param {Object} fields - key/value pairs to send
 * @param {string[]} jsonFields - keys whose value should be JSON.stringify'd
 *                                 before being sent (e.g. nested objects like
 *                                 backup_attributes, quantity, unit, amount, created_by)
 */
export function buildFormBody(fields, jsonFields = []) {
  const params = new URLSearchParams();

  Object.entries(fields).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;

    if (jsonFields.includes(key) && typeof value !== "string") {
      params.append(key, JSON.stringify(value));
    } else {
      params.append(key, String(value));
    }
  });

  return params;
}

/**
 * POSTs to a form-urlencoded "action" based endpoint
 * (GET / GETBYID / ADDUPDATE / DELETE pattern).
 */
export async function postAction(url, fields, jsonFields = []) {
  return fetchWrapper(url, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: buildFormBody(fields, jsonFields),
  });
}

/**
 * Safely parse a value that the backend may return either as a JSON string
 * or as an already-parsed object (MySQL JSON columns are inconsistent about this).
 */
export function safeParseJson(value, fallback = {}) {
  if (value == null) return fallback;
  if (typeof value === "object") return value;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}